import React from "react";

export const NotFound = () => {
  return (
    <div className="not-found">
      <div className="four-zero">
        <h2>Oops!</h2>
        <small>Nah.. it's 404</small>
        <footer>
          <a href={`/FaultReporter/admin/customerfacilityfault`}>
            <i className="zmdi zmdi-home"></i>
          </a>
        </footer>
      </div>
    </div>
  );
};
